import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=72678c9c&scoped=true"
import script from "./projectList.vue?vue&type=script&lang=js"
export * from "./projectList.vue?vue&type=script&lang=js"
import style0 from "./projectList.vue?vue&type=style&index=0&id=72678c9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72678c9c",
  null
  
)

export default component.exports